import type { ProjectPageLoader } from '@modules/project/type';
import MetricStats from '~/modules/metric-stats/component/MetricStats';

type StatsData = ProjectPageLoader['project']['Professional'];
interface StatsProps {
    data: StatsData;
}

const getMetricData = (data: StatsData) => {
    return {
        projectCount: String(data.ProjectCount),
        profileLink: data.Link,
    };
};

const Stats = ({ data }: StatsProps) => {
    const { projectCount, profileLink } = getMetricData(data);

    return (
        <MetricStats
            stats={[
                {
                    label: 'Projects published',
                    link: `${profileLink}/case-studies`,
                    testID: 'projects-count',
                    data: projectCount,
                },
            ]}
        />
    );
};

export default Stats;
